export default "__VITE_ASSET__DIHgj$Ig__"